import { unsubscribeOnDestroy } from './unsubscribe-on-destroy.func';
export function Unsubscribe(observables) {
    return function (target) {
        unsubscribeOnDestroy(target, observables);
    };
}
//# sourceMappingURL=reactive-decorator.unsubscribe.func.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/reactive/decorator/unsubscribe/src/reactive-decorator.unsubscribe.func.js
// module id = 928
// module chunks = 7